import React from 'react';
import classNames from 'classnames/bind';
import styles from './Greetings.module.scss';

interface Props {
  greeting: string;
  username?: string;
  multipleAccountLabel?: string;
  hasMultipleAccounts?: boolean;
}

const Greetings = ({
  greeting,
  username,
  hasMultipleAccounts,
  multipleAccountLabel,
}: Props) => {
  return (
    <div className={styles.greetings}>
      <div className={classNames(styles.Heading, 'u-textCenter u-marginBz')}>
        {`${greeting} ${username}`}
      </div>
    </div>
  );
};

export default Greetings;
